import { Component, ViewChild, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';



@Component({
  selector: 'app-payersclaimtype',
  templateUrl: './payersclaimtype.component.html',
  styleUrls: ['./payersclaimtype.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})

export class PayersclaimtypeComponent implements OnInit {

  columnsToDisplay = ['payername', 'claimtype', 'plannames', 'Action'];
  headercolumnsToDisplay = ['Payer Name', 'Claim Type', 'Plan Names', 'Action'];
  dataSource = [];// new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  expandedElement: any | null;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  public show: boolean = false;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  payersclaimform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.payersclaimform = this.formBuilder.group({

      payername: ['',],
      claimtype: ['',],
      planname: ['',],
      payernames: ['',],
      claimtypes: ['',],
      plannames: ['',],


    });
    //this.dataSource.paginator = this.paginator;

  }

  get f() { return this.payersclaimform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.payersclaimform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.payersclaimform.value))
  }
}


